import { render, staticRenderFns } from "./Parent_calculate.vue?vue&type=template&id=3bdf24cf&scoped=true"
import script from "./Parent_calculate.vue?vue&type=script&lang=js"
export * from "./Parent_calculate.vue?vue&type=script&lang=js"
import style0 from "./Parent_calculate.vue?vue&type=style&index=0&id=3bdf24cf&prod&lang=css"
import style1 from "./Parent_calculate.vue?vue&type=style&index=1&id=3bdf24cf&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdf24cf",
  null
  
)

export default component.exports